import { Vue } from 'vue-property-decorator';
import classNames from "../../../lib/utils/classNames";
export const ICMBTButton = Vue.extend({
  name: 'SmallButton',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    highlighted: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const h = arguments[0];
    const {
      icon,
      title,
      highlighted
    } = this;
    return h("a-tooltip", {
      "attrs": {
        "title": title,
        "overlayStyle": {
          'pointer-events': 'none'
        },
        "placement": "left"
      },
      "class": classNames('ucd-ICMBT-SmallButton', {
        highlighted
      }),
      "on": {
        "click": () => this.$emit('click')
      }
    }, [h("div", [!!icon && h("i", {
      "class": `fa fa-${icon}`,
      "attrs": {
        "aria-hidden": "true"
      }
    }), !!this.$slots.default && ' ', this.$slots.default])]);
  }
});
//# sourceMappingURL=ICMBTButton.js.map
